
import {Vue} from "vue-class-component";

export default class NoSongs extends Vue {
  addSong() {
    this.$router.push({name: 'addSong'});
  }
}
